<template>
  <el-card>
    <el-button type="primary" @click="getTableData">{{ $t('channel.label.refresh') }}</el-button>
    <el-button type="primary" @click="dialogVisible = true">{{ $t('device.all.edit') }}</el-button>
    <el-row style="margin: 10px 0;">
      <el-table border :data="tableList" :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }" :row-key="rowKey" @selection-change="handleSelectionChange" stripe>
        <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="channelCode" align="center" :label="$t('channel.label.channelCode')" />
        <el-table-column prop="channelName" align="center" :label="$t('channel.label.channelName')" />
        <el-table-column prop="maxAmount" align="center" :label="$t('channel.label.singleMaxLimit')" />
        <el-table-column prop="minAmount" align="center" :label="$t('channel.label.singleMinLimit')" />
        <el-table-column prop="createAcct" align="center" :label="$t('channel.label.createAcct')" />
        <el-table-column prop="createTime" align="center" :label="$t('channel.label.createTime')">
          <template slot-scope="{ row }">
            {{ row.createTime | asDayjs }}
          </template>
        </el-table-column>
        <el-table-column prop="isOpen" align="center" :label="$t('channel.label.status')">
          <template slot-scope="{ row }">
            <p>
              <el-tag v-for="item in statusData" :key="item.label" :type="item.type" v-show="item.value === row.isOpen">
                {{ item.label }}
              </el-tag>
            </p>
          </template>
        </el-table-column>

        <el-table-column width="200" prop="tripleChannelList" align="center" :label="$t('channel.label.supported')">
          <template slot-scope="{ row }">
            <template v-if="row.tripleChannelList && row.tripleChannelList.length > 0">
              <i v-for="item in row.tripleChannelList" :key="item.id"
                :style="{color: item.status === 0 ? 'red':'#67c23a'}">
                {{item.tripleChannel+','}}
              </i>
            </template>
            <p v-else style="color: red">
              N/A
            </p>
            <!--            <p style="color: #409eff">-->
            <!--              {{showTripleChannel(row.tripleChannelList)}}-->
            <!--            </p>-->
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('channel.label.action')">
          <template slot-scope="{ row }">
            <el-popconfirm :ref="`popover-${row.id}`" :key="row.id" :title="$t('orders.tip.danger')"
              @confirm="handleEditor(row)">
              <el-button slot="reference" type="primary" size="mini">
                {{ $t("btns.editor") }}
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-pagination v-bind="pageOption" @size-change="getTableData" @current-change="getTableData"
      :current-page.sync="pagination.current" :total="tableData.rows" />

    <v-editor ref="editor" :statusData="statusData" :rules="formProps.form.rules" @doConfUpdate="doConfUpdate" />
    <el-dialog :title="$t('device.all.edit')" :visible.sync="dialogVisible" width="30%">
      <el-radio-group v-model="batchStatus">
        <el-radio :label="1">{{ $t("status.open") }}</el-radio>
        <el-radio :label="0">{{ $t("status.error2") }}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("status.Cancel") }}</el-button>
        <el-button type="primary" @click="batchOperation">{{ $t("status.confor") }}</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
  import { debounce } from "lodash";
  import channelApi from "@/api/channel";
  import vEditor from "./editor";

  export default {
    name: 'channelConf',
    components: { vEditor },
    data() {
      return {
        form: {
          channelCode: "",
          channelType: "",
          createAcct: "",
          createTime: "",
          serviceType: "",
          isOpen: ""
        },
        pagination: {
          no: 1,
          size: 999
        },
        tableData: {},
        pageOption: {
          'page-count': 1,
          background: true,
          'page-sizes': [100],
          layout: 'total, sizes, prev, pager, next, jumper'
        },
        select: [],
        dialogVisible: false,
        batchStatus: 1,
      };
    },
    computed: {
      tableList() {
        return this.tableData.list || [];
      },
      statusData() {
        return [
          {
            label: this.$t("status.success2"),
            type: "success",
            value: 1
          },
          {
            label: this.$t("status.error2"),
            type: "error",
            value: 0
          }
        ];
      }
    },
    created() {
      this.init();
    },
    mounted() {
      this.getTableData();
    },
    methods: {
      init() {
        this.handleSearch = debounce(this._handleSearch, 300);

        /* ----------------------------- element -props ----------------------------- */
        this.formProps = {
          form: {
            ref: "form",
            "label-width": "auto",
            inline: true,
            size: "small",
            rules: {
              channelCode: [
                {
                  required: true,
                  message: this.$t("channel.rules.channelCode"),
                  trigger: "change"
                }
              ],
              channelName: [
                {
                  required: true,
                  message: this.$t("channel.rules.channelName"),
                  trigger: "change"
                }
              ]
            }
          }
        };
      },
      formatParams() {
        return {
          ...Object.keys(this.form).reduce((acc, key) => {
            if (this.form[key] === 0 || this.form[key]) {
              acc[key] = this.form[key];
            }
            if (key === "channelCode") {
              acc.channelCode = "";
            }
            return acc;
          }, {})
          // ...this.pagination
        };
      },
      async getTableData() {
        const { data } = await channelApi.getChannelPage({ data: this.pagination });
        if (data && data.code == 200) {
          this.tableData = data.data;
        }
      },
      async doConfUpdate(formUpdate, cb) {
        const params = {
          ...formUpdate
        };
        const { data } = await channelApi.channelUpdate(params);
        if (data.success) {
          cb();
        } else {
          this.$message.error(data.message);
        }
        // this.tableData = res.data.data;
        this.getTableData();
      },
      /* --------------------------------- 事件驱动函数 --------------------------------- */
      handleEmpty() {
        this.form = {
          id: "",
          channelName: "",
          createAcct: "",
          createTime: "",
          isOpen: ""
        };
      },
      handleEditor(row) {
        this.$refs.editor.init(row);
      },
      _handleSearch() {
        this.$refs.form.validate(async (valid) => valid && this.getTableData());
      },


      rowKey(row) {
        return row.id;
      },
      handleSelectionChange(list) {
        this.select = list;
      },
      async  batchOperation() {
        const selectedItems = this.select || [];
        if (selectedItems.length === 0) {
          this.$message({
            type: 'info',
            message:this.$t('status.choose')
          });
          return;
        }
        const idList = selectedItems.map(item => item.id);
        const params = {
          ids:idList,
          isOpen: this.batchStatus
        };
        try {
          const { data } = await channelApi.updateBatch(params);
          if (data.code == 200) {
            this.$message.success(data.message || '操作成功');
            this.dialogVisible = false;
          } else {
            this.$message.error(data.message || '操作失败');
          }
        }catch (error) {
          this.$message.error('请求失败，请稍后重试');
        }finally {
          this.getTableData();
        }
      }


      // showTripleChannel(list){
      //   if (list.length > 0) {
      //     return <i>N/A</i>
      //   } else {
      //     return list.filter(sItem=>sItem.status === 1).map(item=>item.tripleChannel).join(', ')
      //   }
      // }
    }
  };
</script>

<style lang="scss" scoped>
  /deep/ .el-pagination {
    text-align: right;
  }

  i {
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/channeltypemanage/index.vue